import { create } from 'zustand';

interface WebSocketState {
  isConnected: boolean;
  status: 'disconnected' | 'connecting' | 'connected' | 'error';
  error: string | null;
  setConnected: (connected: boolean) => void;
  setStatus: (status: 'disconnected' | 'connecting' | 'connected' | 'error') => void;
  setError: (error: string | null) => void;
}

export const useWebSocketStore = create<WebSocketState>((set) => ({
  isConnected: false,
  status: 'disconnected',
  error: null,
  setConnected: (connected) => set({ isConnected: connected }),
  setStatus: (status) => set({ status }),
  setError: (error) => set({ error }),
}));
